import { Component } from 'utils';
import { applicationActions } from '../store/reducers/applicationReducer';
import {licenseActions} from '../store/reducers/licenseReducer';

@Component({
    controllerAs: 'app',
    template: require('./tpl.html'),
    styles: [
        require("../styles/styles.scss"),
        require('../../node_modules/angular-material/angular-material.scss')
    ]
})
export class AppComponent {
    static $inject = ['store','sessionService'];

    constructor(store,sessionService) {
        this.sessionService = sessionService;
        this.store = store;
        this.pending = false;
        this.pendingMessage = '';
        const warningKey="warning"; 
        const warningText=this.sessionService.get(warningKey);

        
        this.store.dispatch({
            type: licenseActions.SET_LICENSE_WARNING,
            payload: {warningText: warningText}
        });
        
        this.unsubscribe = this.store.subscribe(() => {
            let alert = this.store.getState().application.alert;
            this.alerts = [];
            if (alert && alert.type) {
                this.alerts = [...this.alerts, alert];
            }
            let pending = this.store.getState().application.pending;
            if (pending) {
                this.pending = pending.active;
                this.pendingMessage = pending.message;
            }
        });

        this.$onDestroy = function () {
            this.unsubscribe();
        };
    }
    closeAlert() {
        this.alerts.length = 0;
        this.store.dispatch({ type: applicationActions.CLEAR_ALERTS, payload: { alert: {} } });
    }
}



// WEBPACK FOOTER //
// ./src/app/app.js